export const MAX_DEVICE_OPTIONS = 50;
